export default __webpack_public_path__ + "static/media/group-7797.cf527997.png";